import OnboardingGuide from 'components/Onboarding/OnboardingGuide'
import McpIcon from 'components/icons/McpIcon'
import './MayaMcp.scss'

// The full guide for connecting an AI assistant (Claude, ChatGPT, Copilot Studio, …) to Maya
// via MCP: setup, verify, starter prompts, category reference, privacy. In the app this is
// always the "Ask Maya" tab of the Data & Insights flow (`embedded` — the shell provides the
// tab label, so the page's own title hides); the non-embedded header is kept intentionally so
// the page still works if mounted standalone.
const MayaMcp = ({ embedded = false }: { embedded?: boolean }) => (
  <div className="maya-mcp-page">
    <div className="maya-mcp-header">
      {!embedded && (
        <h1>
          <McpIcon className="maya-mcp-header__icon" />
          Maya MCP
        </h1>
      )}
      <p className="subtitle-text">
        Connect an AI assistant — Claude, ChatGPT, Microsoft Copilot Studio — to your Maya data and
        start asking questions across all your channels.
      </p>
    </div>
    <OnboardingGuide variant="full" />
  </div>
)

export default MayaMcp
